import { DomUtils } from './utils';

class ScrollAnimations {
    constructor() {
        this.DOM = {
            body: document.body
        };

        this.viewportWidth = DomUtils.getViewportWidth();
        this.vw = this.viewportWidth / 100;

        this.triggerElementsInView();
        this.triggerElementsInViewLater();

        this.triggerParallax();
        this.triggerBackgroundScale();
        this.triggerFooterInView();
    }

    // The background scales from 1.1 to 1 while the top of the block scrolls from the bottom to the top of the viewport
    triggerBackgroundScale() {
        const backgrounds = document.querySelectorAll('.background-scale .background');
        if (!backgrounds.length) {
            return;
        }

        backgrounds.forEach((background) => {
            gsap.fromTo(
                background,
                { scale: 1.05, borderRadius: 0 },
                {
                    scale: 1,
                    borderRadius: () => getComputedStyle(background.parentElement).borderRadius, // the radius of the block, recalculated on resize
                    ease: 'none',
                    scrollTrigger: {
                        // markers: true,
                        trigger: background.parentElement, // the unscaled block, the scaled background would offset the start position
                        start: 'top bottom',
                        end: 'top center',
                        scrub: 0.5,
                        invalidateOnRefresh: true
                    }
                }
            );
        });
    }

    triggerFooterInView() {
        const footer = document.querySelector('.site-footer');
        if (!footer) {
            return;
        }

        // The footer is sticky on desktop (ScrollTrigger would measure its stuck position), so the bottom of the content above it is used
        const trigger = footer.previousElementSibling || footer;

        ScrollTrigger.create({
            trigger: trigger,
            start: trigger === footer ? 'top bottom' : 'bottom bottom',
            onEnter: () => this.DOM.body.classList.add('footer-in-view'),
            onLeaveBack: () => this.DOM.body.classList.remove('footer-in-view')
        });
    }

    triggerParallax() {
        const triggerElements = document.querySelectorAll('.trigger-parallax');
        console.log('triggerElements :', triggerElements);
        if (!triggerElements.length) {
            return;
        }
        triggerElements.forEach((element) => {
            let media = element.querySelectorAll('img, video');
            console.log('media :', media);
            const isParallaxTop = element.classList.contains('parallax-top');
            if (!media) {
                return;
            }
            gsap.fromTo(
                media,
                { y: isParallaxTop ? '0%' : '-5%', scale: '1.085' }, // Start position
                {
                    y: '5%',
                    scale: '1.085', // End position
                    ease: 'power1.inOut', // Smooth easing for scroll speed
                    scrollTrigger: {
                        // markers: true,
                        trigger: element, // Element to trigger the scroll animation
                        start: isParallaxTop ? 'top top' : 'top bottom', // Animation starts when top of element hits bottom of viewport
                        end: 'bottom top', // Animation ends when bottom of element hits top of viewport
                        scrub: 0.5, // Smooth scrubbing with 1 second delay
                        invalidateOnRefresh: true
                    }
                }
            );
        });
    }

    // Adds the in-view class and dispatches an 'in-view-block-{slug}' event the first time
    setInView(element) {
        if (element.classList.contains('in-view')) {
            return;
        }

        element.classList.add('in-view');

        element.classList.forEach((className) => {
            if (className.startsWith('block-')) {
                element.dispatchEvent(new CustomEvent(`in-view-${className}`, { bubbles: true }));
            }
        });
    }

    triggerElementsInView() {
        if (!document.querySelectorAll('.trigger-in-view')) {
            return;
        }

        ScrollTrigger.batch('.trigger-in-view', {
            // markers: true,
            start: 'center bottom',
            end: 'bottom top',
            onEnter: (elements) => {
                elements.forEach((element) => this.setInView(element));
            },
            onEnterBack: (elements) => {
                elements.forEach((element) => this.setInView(element));
            }
        });
    }

    triggerElementsInViewLater() {
        if (!document.querySelectorAll('.trigger-in-view-later')) {
            return;
        }

        ScrollTrigger.batch('.trigger-in-view-later', {
            // markers: true,
            start: 'top 70%',
            end: 'bottom top',
            onEnter: (elements) => {
                elements.forEach((element) => this.setInView(element));
            },
            onEnterBack: (elements) => {
                elements.forEach((element) => this.setInView(element));
            }
        });
    }
}
new ScrollAnimations();
